import {
  type Epic,
  type Feature,
  type Requirement,
} from 'components/framework/models';
import RecordAction from '../RecordAction';
import ApplicationModel from 'components/framework/ApplicationModel';
import { type HasRecordPositions } from 'components/framework/models/concerns/HasRecordPositions';

const { Project, BookmarksTeamBacklog, BookmarksWorkflowBoard } =
  ApplicationModel.models;

type Record = (Epic | Feature | Requirement) & HasRecordPositions;

export class UnassignFromTeamAction extends RecordAction<Record> {
  recordTypes = ['Epic', 'Feature', 'Requirement'];
  menuItemType = 'danger' as const;

  get title() {
    return `Unassign from team`;
  }

  showForRecord(record: ApplicationModel): record is Record {
    const isTeamAssignable =
      'assignToTeam' in record && typeof record.assignToTeam === 'function';
    return (
      super.showForRecord(record) &&
      isTeamAssignable &&
      record.team?.id !== record.project?.id
    );
  }

  showForSelectedRecords() {
    return !!(
      window.currentAccount?.teamworkOrDevelopFlavor &&
      window.currentProject?.id &&
      this.selectedRecords.every(record => {
        return (
          record.team?.id &&
          record.team?.id === this.selectedRecords[0].team?.id &&
          this.showForRecord(record)
        );
      })
    );
  }

  async runForRecords(records: Record[]) {
    const teamId: string | undefined = records[0].team?.id;
    if (!teamId) {
      return;
    }
    const team = await Project.select('backlogBookmarkId')
      .merge({ workflowBoardBookmark: ['id'] })
      .find(teamId);

    await Promise.all(
      records.flatMap(record => {
        return [
          record.removeRecordPosition({
            bookmarkType: BookmarksTeamBacklog.bookmarkName,
            bookmarkId: team.backlogBookmarkId as RecordId,
            secondaryScopeId: team.backlogBookmarkId as RecordId,
          }),
          record.removeRecordPosition({
            bookmarkType: BookmarksWorkflowBoard.bookmarkName,
            bookmarkId: team.workflowBoardBookmark?.id as RecordId,
            all: true,
          }),
          record.update(
            { team: Project.blank() },
            { resetAttributes: true, args: { __reactivelyUpdate: true } }
          ),
        ];
      })
    );
  }
}
